import moment from 'moment';

class ArrivalListController {

    constructor(time, loadingService) {
        this.time = time;
        this.loadingService = loadingService;
    }

    $onInit () {
        this.momentDate = moment();

        if (this.date === 'tomorrow') {
            this.momentDate.add(1, 'day');
        }

        this.displayDate = `${this.date[0].toUpperCase()}${this.date.substr(1)}: ${this.momentDate.format('dddd LL')}`;
    }

    displayTime (time) {
        return moment.utc(`${this.momentDate.format('YYYY-MM-DD')} ${time}`).format('h:mm A');
    }

    isLoading () {
        return this.loadingService.isLoading(this.date);
    }
}
ArrivalListController.$inject = ['time', 'loadingService'];

export default ArrivalListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/guests/controllers/arrival.list.controller.js